import { treatments } from '@App/data/treatments.json';

import { Treatment } from './types/Treatment';

export async function getTreatments(): Promise<Treatment[]> {
  return <Treatment[]>treatments;
}
